var DONEGDPRParams = {
    color: '#5F4B8B',
    lang: jQuery('html').attr('lang').substr(0, 2),
    policy_url: localize.cookie,
    groups: {
        always_active: [{
            name: 'Google (NID, CONSENT, P_JAR, HSID, APISID, SAPISID, SID, SIDCC, SSID)'
        }, {
            name: 'akvariumklub.hu saját sütijei (PHPSESSID, DONEGDPRConsent, DONEGDPRAlertBoxClosed, wp-wpml_current_language)'
        }],
        performance: [{
            name: 'Google Analytics (_ga, _gat, _gid)',
        }, {
            name: 'Google Tag Manager (_dc_gtm_UA-#)',
        }
        ],
        functional: [{
            name: 'Spotify (sp_t, sp_landing, spot, _gcl_au, sp_ab, cookieNotice)'
        }, {
            name: 'Youtube (HSID, YSC, SID, PREF, APISID,  SSID, LOGIN_INFO, VISITOR_INFO1, _LIVE, SAPISID, CONSENT, GPS)'
        }

        ],
        targeting: [{
            name: 'Facebook (fr, _fbp)'
        }
        ]
    }
};


(function ($) {
    "use strict";

    $(function () {

        $.cookieSettings = Cookies.get('DONEGDPRConsent');

        if ($.cookieSettings != undefined) {
            $.cookieSettings = JSON.parse($.cookieSettings);
        }

        if ($.cookieSettings != undefined && $.cookieSettings.targeting == true) {

            if (localize.fbpixel != undefined) {
                !function (f, b, e, v, n, t, s) {
                    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) };
                    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
                    n.queue = []; t = b.createElement(e); t.async = !0;
                    t.src = v; s = b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t, s)
                }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

                $.each(localize.fbpixel, function (i, e) {
                    fbq('set', 'autoConfig', false, e);
                    fbq('init', e);
                });

                fbq('track', 'PageView');
            }

        }

        if ($.cookieSettings != undefined && $.cookieSettings.performance == true) {
            window['ga-disable-UA-39802959-1'] = false;

            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }

            gtag('js', new Date());
            gtag('config', 'UA-39802959-1');
        } else {
            window['ga-disable-UA-39802959-1'] = true;

            var cookies = Cookies.get();

            if ('' !== cookies) {

                $.each(cookies, function (index) {

                    index = '' + index;


                    if ('_ga' === index || '_gid' === index || '_gat' === index) {
                        Cookies.remove(index, { domain: document.domain });
                    }

                });

            }
        }

        $(document).on('click', '.js-open-cookie a', function (e) {
            e.preventDefault();
            cookiedone.showCookieSettings();

            if ($.cookieSettings != undefined && $.cookieSettings.performance == true) {
                $('.done-gdpr-status-checkbox.performance').attr('checked', true)
            }
            if ($.cookieSettings != undefined && $.cookieSettings.functional == true) {
                $('.done-gdpr-status-checkbox.functional').attr('checked', true)
            }
            if ($.cookieSettings != undefined && $.cookieSettings.targeting == true) {
                $('.done-gdpr-status-checkbox.targeting').attr('checked', true)
            }
        });

        $(document).on('click', '#done-gdpr-save-button', function (e) {
            location.reload();
        });


        $(document).on('click', '.done-gdpr-button-allow', function (e) {
            e.preventDefault();
            e.stopPropagation();
            cookiedone.allowAll();
            location.reload();
        });


        moment.locale($('html').attr('lang'));

        AOS.init({
            disable: 'mobile'
        });

        $('.js-search-button').click(function () {
            $('body').addClass('search-active');
            $('.input-search').focus();
        });

        $('.icon-close,.search-overlay').click(function () {
            $('body').removeClass('search-active');
        });

        objectFitImages();

        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        var isIE = /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /MSIE 10/i.test(navigator.userAgent) || /Edge\/\d+/.test(navigator.userAgent);

        if (!isMobile) {
            $('.jarallax:not(.js-jarallax-video)').jarallax({
                disableParallax: function () {
                    return /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /MSIE 10/i.test(navigator.userAgent) || /Edge\/\d+/.test(navigator.userAgent);
                },
            });
        }

        $('.js-sticky-sidebar').stickySidebar({
            topSpacing: $('#menu').outerHeight(),
            bottomSpacing: 0,
            containerSelector: '.sticky-container',
            innerWrapperSelector: '.sticky-menu-category',
            resizeSensor: true,
            minWidth: 991
        });

        $('.js-sticky').stickySidebar({
            topSpacing: 0,
            bottomSpacing: 0,
            containerSelector: '.js-sticky-container',
            innerWrapperSelector: '.js-sticky-inner',
            resizeSensor: true,
            minWidth: 0
        });

        $('.js-sticky-hero-sidebar').stickySidebar({
            topSpacing: 226,
            bottomSpacing: 0,
            containerSelector: '.js-single-programs-sticky-container',
            innerWrapperSelector: '.js-sticky-hero-sidebar__inner',
            resizeSensor: true,
            minWidth: 991
        });

        $('.js-custom-select').SumoSelect();

        $('.js-sticky-location-sidebar').stickySidebar({
            topSpacing: $('#menu').outerHeight() + ($(window).height() - $('#menu').outerHeight()) / 2 - $('.sticky-menu-location').height() / 2,
            bottomSpacing: 0,
            containerSelector: '.sticky-container',
            innerWrapperSelector: '.sticky-menu-location',
            resizeSensor: true
        });

        $('.js-open-filters').on('click', function () {
            $(this).toggleClass('active');
            $('.js-filters-wrapper').slideToggle();
        });

        function animateSlider(params) {

            if (jQuery('#pagination .active').is(':last-child')) {
                jQuery('#pagination :first-child').click();
            } else {
                jQuery('#pagination .active').next().click();
            }
        }



        var $pause = $('#slider').data('pause');
        var $animateSpeed = parseInt($('#slider').data('animatespeed'));

        if (jQuery('#fullscreen-slider').css('display') == 'block') {

            var timer = setInterval(function () { animateSlider() }, $animateSpeed);

            if ($pause) {
                $('#fullscreen-slider').hover(function (ev) {
                    clearInterval(timer);
                }, function (ev) {
                    timer = setInterval(animateSlider, $animateSpeed);
                });
            }
        }

        $('#pagination button').on('click', function () {
            if (!$pause) {
                clearInterval(timer);
                timer = setInterval(animateSlider, $animateSpeed);
            }
        })

        $("#modal-alert").iziModal();
        $("#modal-success").iziModal();




        $('#search-field').on('keyup', function (e) {
            var searchString = $(this).val();
            e.preventDefault();

            $('.js-card-menu').show().filter(function () {
                var $search_keyword = searchString.toLowerCase().trim();
                return $(this).text().toLowerCase().trim().indexOf($search_keyword) == -1;
            }).hide();

            $('.js-sub-category').each(function (i, e) {
                $(this).show();
                if ($(this).find('.js-card-menu:visible').length == 0) {
                    $(this).hide();
                }
            });


            $('.js-main-category').each(function (i, e) {
                $(this).find('.js-no-result').hide();
                if ($(this).find('.js-sub-category:visible').length == 0) {
                    $(this).find('.js-no-result').show();
                }
            });

        });

    });

})(jQuery);